import { defineStore } from 'pinia';
import { userApi } from '@/service/api/user';

interface UserInfo {
  id?: string | number;
  mobile?: string;
  name?: string;
  [key: string]: any;
}

export const useUserStore = defineStore('user', {
  state: () => {
    // 从 localStorage 初始化状态
    const token = localStorage.getItem('token') || '';
    const userInfoStr = localStorage.getItem('userInfo');
    let userInfo: UserInfo | null = null;
    if (userInfoStr) {
      try {
        userInfo = JSON.parse(userInfoStr);
      } catch {
        userInfo = null;
      }
    }

    return {
      token,
      userInfo
    };
  },

  getters: {
    isLogin: state => !!state.token
  },

  actions: {
    async login(mobile: string, password: string) {
      try {
        const res = await userApi.login({ mobile, password });
        this.token = res.data.token || '';
        this.userInfo = res.data;
        // 手动同步到 localStorage（如果使用持久化插件可移除）
        this.syncToStorage();
        return res;
      } catch (error) {
        throw error;
      }
    },

    logout() {
      this.token = '';
      this.userInfo = null;
      // 清除 localStorage
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
    },

    // 同步状态到 localStorage
    syncToStorage() {
      if (this.token) {
        localStorage.setItem('token', this.token);
      }
      if (this.userInfo) {
        localStorage.setItem('userInfo', JSON.stringify(this.userInfo));
      }
    }
  }

  // 如果安装了 pinia-plugin-persistedstate，可以使用以下配置替代手动同步：
  // persist: {
  //   enabled: true,
  //   strategies: [
  //     {
  //       key: 'user',
  //       storage: localStorage,
  //       paths: ['token', 'userInfo']
  //     }
  //   ]
  // }
});
